import Flex from '@Components/Bases/Flex';
import { FormInput, FormTextEditor } from '@Components/Form';
import { disabledFormInputStyles } from '@Components/Form/styles';
import { Typography } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { IGreenhouseStrategyFormValues } from '../../EsgGreenhouseFormProvider/types';

const GreenhouseStrategyPlanForm = () => {
  const { completedSection } =
    useWatch({
      name: 'greenhouseStrategy',
    }) ?? ({} as IGreenhouseStrategyFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};
  return (
    <>
      <FormTextEditor
        mt={2}
        name="greenhouseStrategy.plan.descriptionTh"
        label="อธิบายรายละเอียดแผนการจัดการก๊าซเรือนกระจก (ไทย)"
        required
        inputProps={{
          placeholder: 'กรุณาระบุ (ไทย)',
        }}
        sx={isCompletedTh ? disabledFormInputStyles : undefined}
      />
      <Flex width={1} my={2} alignItems={'center'}>
        <Typography width={1 / 3}>
          ลิงก์แผนการจัดการก๊าซเรือนกระจกของบริษัท (ไทย) (ถ้ามี)
        </Typography>
        <FormInput
          sx={{
            width: 1 / 3,
            marginRight: 4,
            ...(isCompletedTh ? disabledFormInputStyles : {}),
          }}
          label="ลิงก์"
          name="greenhouseStrategy.plan.urlTh"
          placeholder="กรุณาระบุลิงก์"
          slotProps={{
            input: {
              readOnly: isCompletedTh,
            },
          }}
        />
        <FormInput
          sx={{
            width: 1 / 3,
            ...(isCompletedTh ? disabledFormInputStyles : {}),
          }}
          label="เลขหน้าของลิงก์"
          name="greenhouseStrategy.plan.pageNumberTh"
          placeholder="กรุณาระบุเลขหน้า"
          slotProps={{
            input: {
              readOnly: isCompletedTh,
            },
          }}
        />
      </Flex>
      <FormTextEditor
        mt={2}
        name="greenhouseStrategy.plan.descriptionEn"
        label="อธิบายรายละเอียดแผนการจัดการก๊าซเรือนกระจก (อังกฤษ)"
        required
        inputProps={{
          placeholder: 'กรุณาระบุ (อังกฤษ)',
        }}
        sx={isCompletedEn ? disabledFormInputStyles : undefined}
      />
      <Flex width={1} my={2} alignItems={'center'}>
        <Typography width={1 / 3}>
          ลิงก์แผนการจัดการก๊าซเรือนกระจกของบริษัท (อังกฤษ) (ถ้ามี)
        </Typography>
        <FormInput
          sx={{
            width: 1 / 3,
            marginRight: 4,
            ...(isCompletedEn ? disabledFormInputStyles : {}),
          }}
          label="ลิงก์"
          name="greenhouseStrategy.plan.urlEn"
          placeholder="กรุณาระบุลิงก์"
          fullWidth
          slotProps={{
            input: {
              readOnly: isCompletedEn,
            },
          }}
        />
        <FormInput
          sx={{
            width: 1 / 3,
            ...(isCompletedEn ? disabledFormInputStyles : {}),
          }}
          label="เลขหน้าของลิงก์"
          name="greenhouseStrategy.plan.pageNumberEn"
          placeholder="กรุณาระบุเลขหน้า"
          slotProps={{
            input: {
              readOnly: isCompletedEn,
            },
          }}
        />
      </Flex>
    </>
  );
};

export default GreenhouseStrategyPlanForm;
